import { useEffect, useRef } from "react";

// Full-page subtle cursor spotlight — cyan radial glow that follows the cursor.
// Disabled on touch devices and when prefers-reduced-motion is set.
export default function CursorGlow() {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const isTouch = window.matchMedia("(hover: none)").matches;
        const prefersReduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (isTouch || prefersReduce) {
            el.style.display = "none";
            return;
        }

        let x = window.innerWidth / 2;
        let y = window.innerHeight / 2;
        let tx = x;
        let ty = y;
        let raf;

        const handleMove = (e) => {
            tx = e.clientX;
            ty = e.clientY;
        };
        const tick = () => {
            x += (tx - x) * 0.12;
            y += (ty - y) * 0.12;
            el.style.transform = `translate3d(${x - 260}px, ${y - 260}px, 0)`;
            raf = requestAnimationFrame(tick);
        };
        window.addEventListener("pointermove", handleMove, { passive: true });
        tick();
        return () => {
            window.removeEventListener("pointermove", handleMove);
            cancelAnimationFrame(raf);
        };
    }, []);

    return (
        <div
            ref={ref}
            aria-hidden="true"
            className="pointer-events-none fixed top-0 left-0 z-[5] w-[520px] h-[520px] rounded-full"
            style={{
                background:
                    "radial-gradient(circle, rgba(0,240,255,0.14) 0%, rgba(255,45,146,0.06) 40%, transparent 70%)",
                filter: "blur(30px)",
                willChange: "transform",
                transform: "translate3d(-1000px, -1000px, 0)",
                mixBlendMode: "screen",
            }}
        />
    );
}
